// Admin email whitelist — add emails of users who should have admin access
export const ADMIN_EMAILS = [
  'dekelohad@gmail.com',
];

export const isAdmin = (email: string | null | undefined): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};
